import { NodeData } from '../TaxonomyTable';

export function EditButton(props: { node: NodeData; showModal: (node: NodeData) => void; }) {
    return <button type="button" className='btn btn-sm btn-icon-only btn-primary rounded-circle' data-pr-tooltip={'Edit ' + props.node.type}
        onClick={() => props.showModal(props.node)}
    ><i className="fas fa-pen"></i></button>;
}
